export function Footer() {
  return (
    <footer className="border-t border-[#262626] bg-[#0A0A0A] mt-24" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 bg-[#00D4FF] flex items-center justify-center">
              <span className="text-black font-chivo font-black">D</span>
            </div>
            <span className="font-chivo font-black text-white text-lg uppercase tracking-tight">Dry Ice Connect</span>
          </div>
          <p className="font-plex text-sm text-[#9CA3AF] max-w-xs leading-relaxed">
            Private resource center for dry ice blasting contractors, equipment owners, and industrial cleaning businesses. Built and operated by Dry Ice Bulls.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[11px] text-[#00D4FF] tracking-widest uppercase mb-4">Platform</div>
          <ul className="space-y-2 text-sm text-[#9CA3AF]">
            <li><a href="/pricing" className="hover:text-white">Pricing</a></li>
            <li><a href="/inventory" className="hover:text-white">Inventory</a></li>
            <li><a href="/register" className="hover:text-white">Join</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[11px] text-[#00D4FF] tracking-widest uppercase mb-4">Members</div>
          <ul className="space-y-2 text-sm text-[#9CA3AF]">
            <li><a href="/training" className="hover:text-white">Training</a></li>
            <li><a href="/downloads" className="hover:text-white">Downloads</a></li>
            <li><a href="/support" className="hover:text-white">Support</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[11px] text-[#00D4FF] tracking-widest uppercase mb-4">Legal & Contact</div>
          <ul className="space-y-2 text-sm text-[#9CA3AF]">
            <li><a href="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms of Service</a></li>
            <li><a href="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</a></li>
            <li><a href="/refund-policy" className="hover:text-white" data-testid="footer-refund-link">Refund Policy</a></li>
            <li><a href="mailto:support@dryiceconnect.com" className="hover:text-white">support@dryiceconnect.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#262626] py-6 px-4 lg:px-8 max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-mono text-[#52525B]">
        <div>© {new Date().getFullYear()} DRY ICE BULLS. ALL RIGHTS RESERVED.</div>
        <div>V1.0 — STATUS: <span className="text-[#00D4FF]">OPERATIONAL</span></div>
      </div>
    </footer>
  );
}
